export default {"src":"/_next/static/media/trust-banner-bg-mobile.07a01337.svg","height":492,"width":345,"blurWidth":0,"blurHeight":0};